import { ReactNode } from 'react';

import { RichText } from '@boss/rich-text';
import { SimpleImage } from '@boss/types/b2b-b2c';
import { CardCtaFields } from '@boss/types/corporate-jobs';

import ComponentMapper from '../ComponentMapper';

type Cta = {
  href: string;
  id: string;
  label: string;
};

const getCardCtaProps = (
  entry: CardCtaFields,
  locale: string,
  hasBackground: boolean,
): {
  cta?: Cta;
  description?: ReactNode;
  image: SimpleImage;
  title?: string;
  textClassName?: string;
} => ({
  title: entry.title ?? undefined,
  description: entry.description ? (
    <RichText ComponentMapper={ComponentMapper} content={entry.description} mapperOptions={{ locale }} />
  ) : null,
  image: {
    imageUrl: entry.image?.image.file.url,
    imageAlt: entry.image?.image.title,
    id: entry.image.id,
  },
  cta: {
    href: entry.cta?.externalLink ?? '',
    id: entry.cta?.id,
    label: entry.cta?.label,
  },
  textClassName: hasBackground ? 'text-white' : undefined,
});

export default getCardCtaProps;
